<article class="cost-summary">
  <div>
    <header class="flex cost-summary__header">
      <div>
        <h3 class="cost-summary__title typog-h4">Replacement cost</h3>
      </div>
      <div *ngIf="data?.isProtectionSelected">
        <h3 class="cost-summary__title typog-h4">Protection policy</h3>
      </div>
    </header>
  </div>
  <div>
    <section class="flex cost-summary__section">
      <div class="cost-summary__content">
        <p class="cost-summary__price typog-body-large">
          {{ data?.replacementCost | currency : 'GBP' }}
        </p>
        <p class="margin--none">One-off payment total</p>
      </div>
      <div *ngIf="data?.isProtectionSelected" class="cost-summary__content">
        <p class="cost-summary__price typog-body-large">
          {{ data?.monthlyPayment | currency : 'GBP' }} <small>a month</small>
        </p>
        <p class="margin--none">Policy lasts as long as you like</p>
      </div>
    </section>
  </div>
</article>
